
<div>
	<v-container align="center" justify="center" class="pa-5">
		<v-list-item three-line>
			<v-list-item-content>
				<v-list-item-title class="mb-1 text-center text-wrap"><h1>Preferred locations</h1></v-list-item-title>
			</v-list-item-content>
		</v-list-item>
	</v-container>

	<v-card-text align="center" justify="center" class="justify-center text-left pl-5 pr-5 pb-0 pm-0 text-wrap">
		<v-card-subtitle>Tell us where you would like to work</v-card-subtitle>
		<v-row align="start" justify="center">
			<v-col align="start" justify="center" cols="6" sm="12" md="6">
				<v-select
					v-model="provinceSelected"
					outlined
					:items="province_computed"
					persistent-hint
					label="Where is your home province?"
					@change="filterLocations()"
				></v-select>
			</v-col>
			<v-col align="start" justify="center" cols="6" sm="12" md="6">
				<v-select
					v-model="locations"
					:rules="locationsRules"
					outlined
					:items="region_computed"
					multiple
					chips
					deletable-chips
					:disabled="provinceSelected ? false : true"
					:label="provinceSelected ? 'City/District/Regions for work' : 'Please select a province.'"
					persistent-hint
					:hint="provinceSelected ? 'Multiple regions are accepted' : ''"
				></v-select>
			</v-col>
		</v-row>

		<v-card-subtitle>Confirm the below is your residential address</v-card-subtitle>

		<v-row
			><v-col> <v-text-field v-model="streetAddress" label="Street address" outlined :rules="streetAddressRules"></v-text-field> </v-col
		></v-row>

		<v-row>
			<v-col>
				<v-select
					v-model="province_region"
					outlined
					:items="region_computed"
					:disabled="provinceSelected ? false : true"
					:label="provinceSelected ? 'Enter your home City/District/Region' : 'Please select province above'"
					:rules="regionRules"
				></v-select>
			</v-col>
		</v-row>

		<v-row
			><v-col> <v-text-field v-model="suburb" label="Enter suburb" outlined :rules="suburbRules"></v-text-field> </v-col
		></v-row>

		<v-row align="center" justify="center">
			<v-col align="center" justify="center" :cols="7">
				<DistinctYesNo :initial.sync="willing_to_travel" :errors="willing_to_travel_errors" @input="changeWTT"
					>Are you willing to travel for a long term assignment?</DistinctYesNo
				>
			</v-col>
		</v-row>
	</v-card-text>
</div>
